<template>
  <div class="container">
      <div class="topBar">
          <div class="topBar_left">
              <img class="topBar_left_icon" src="../../../assets/images/icon_arrows_black_left.png" @click="changeDay(0)" />
              <span class="topBar_left_span">{{newDatestr}}</span>
              <img class="topBar_left_icon" src="../../../assets/images/icon_arrows_black_right.png" @click="changeDay(1)" />
          </div>
          <div class="topBar_right" @click="select(1)" v-if="roleId=='2'">
               <span class="topBar_right_span">{{orgname}}</span>
               <img class="topBar_right_icon" src="../../../assets/images/icon_arrows_unfold_down.png" />
          </div>
           <div class="topBar_right"  v-else>
               <span class="topBar_right_span">{{common.userTenantInfo.department}}</span>
           </div>
      </div>
      <div class="topMian">
          <span class="topMian_span1">打卡人数/应到人数</span>
          <div class="topMian_div1">
              <span class="topMian_span2">{{normal+late}}</span>
              <span class="topMian_span3">/</span>
              <span class="topMian_span4">{{normal+late+unNormal}}</span>
          </div>
          <span class="topMian_span8" @click="toSignInList()" >打卡明细</span>
          <div class="topMian_div2">
               <div class="topMian_div3">
                   <span class="topMian_span5">正常</span>
                   <span class="topMian_span6">{{normal}}</span>
               </div>
               <div class="topMian_div3">
                   <span class="topMian_span5">未打卡</span>
                   <span class="topMian_span7">{{unNormal}}</span>
               </div>
               <div class="topMian_div3">
                   <span class="topMian_span5">迟到</span>
                   <span class="topMian_span7">{{late}}</span>
               </div>
          </div>
      </div>

      <div class="tableTop">
          <span class="tableTop_span1">周考勤统计</span>
          <div class="tableTop_right">
              <span :class="['tableTop_right_span',
              isThisWeek==1?'tableTop_right_span_border1':'']" @click="changeWeek(1)" >本周</span>
              <span :class="['tableTop_right_span',
              isThisWeek==0?'tableTop_right_span_border2':'']" @click="changeWeek(0)">上周</span>
          </div>
      </div>
      <div class="tableViewDanwei">单位(人)</div>

       <div class="tableViewBG">
                  <div class="tabletop">
                      <div class="tablenumber">
                          <span v-for="(item,index) in tableNumbels" :key="index" class="tablenumber_text">{{item}}</span>
                      </div>
                      <div class="tableMian">
                          <div class="tableTR"></div>
                          <div class="tableTR1"></div>
                          <div class="tableTR"></div>
                          <div class="tableTR1"></div>
                          <div class="tableTR"></div>
                          <div class="tableTR1"></div>
                          <div class="tablebgLine"></div>
                          <div class="tableBars">
                              <div  v-for="(item,index) in tableList" :key="index" class="tableBar" @click="tableSelect(index)" >
                                  <span v-if="tableSelectIndex==index" class="tableBar_text">{{item.value}}</span>
                                  <div :class="['tableBar_bar',tableSelectIndex==index?'selecttableBar':'']" :style="{height:item.height/2+'px'}"></div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="tableFoot">
                      <div class="tableFoots">
                          <span class="tableFootText" v-for="(item,index) in tableList" :key="index">{{item.name |fdate}}</span>
                      </div>
                  </div>
              </div>
              <!-- // 此处slots为动态传入的值，通过computed来处理，数据通过vuex管理，由于数据为对象数组，需设置 value-key 属性来指定显示的字段名 -->
            <mt-popup  v-model="popupVisible" position="bottom" class="mint-popup">
            <mt-picker class="picker" :slots="pickList" @change="onValuesChange" :visible-item-count="5" :show-toolbar="true" ref="picker" >
                <div class="picker_wrap">
                    <div class="picker_btn" @click="popupVisible=false">取消</div>
                    <div class="picker_btn2" @click="handleConfirm">确认</div>
                </div>
            </mt-picker>
            </mt-popup>
         <div class="bottomView"></div>
         <Tabbar :tab="0" ></Tabbar>
 </div>
</template>
<script>
import Tabbar from "@/pages/smartOffice/StruggleReport/StruggleTabbar.vue";
import Scroll from "@/components/scroll";
import util from "@/utils/util";
import {teamReport ,orgApiList} from "@/utils/api";
import {mapState} from 'vuex';
export default {
    data(){
        return {
            newDate:'',
            newDatestr:'',
            isThisWeek:1,
            thisWeekList:[],
            lastWeekList:[],
            maxTable:200,
            maxValue:200,
            itemsValues:[200 ,150, 130,160, 80,60,145 ],
            tableList:[],
            tableNumbels:[600,500,400,300,200,100],
            tableSelectIndex:-1,
            normal:0,
            roleId:0,
            unNormal:0,
            late:0,
            orgname:"全部部门",
            orgId:'',
            orgList:[],
            orgNameList:[{
                flex: 1,
                values:[] ,
                className: 'slot1',
                textAlign: 'center'
            }],
            //弹框选择
            pickType:'',
            popupVisible:false,
            pickList:[],
        }
    },
    components:{
        Tabbar,
        Scroll
    },
    computed: {
        ...mapState({
        common: state => state.common
        })
    },
     filters: {
       fdate: function (value) {
            if(!value){
                return '';
            }
            var date =new Date(value);
            if(!date){
                return "";
            }
            return util.formatTime(date, 24)
       },
     },
    created(){
        this.roleId = this.common.userTenantInfo.roleId;
        if(this.roleId=='2'){
            this.orgId='';
        }else{
            this.orgId = this.common.userTenantInfo.departmentId
        }
        this.newDate = new Date(); //2
        this.newDatestr = util.formatTime(new Date(),4)

        // console.log("thisweek  == " +thisweek)
        // console.log("lastweek  == " +lastweek)

        this.orgApiListAction();
        //初始化图标数据
        this.getteamReportAction();

    },
    methods:{
        toSignInList(){
            var url ='/smartOffice/StruggleSignInList';
            this.$router.push(url);
        },
        initWeekList(){
             var center =7;
             var num = this.newDate.getDay(); //2
             var zeroDate =new Date();
             zeroDate.setDate(zeroDate.getDate()-num);
             var zeroDate1 = new Date();
             zeroDate1.setDate(zeroDate.getDate()-7);
             var thisweek = [];
             var lastweek = [];
             for(var i=0;i<center;i++){
                var dt  = new Date(zeroDate.getTime());
                //new Date();
                var dt1  = new Date(zeroDate1.getTime());
                //new Date();
                dt.setDate(dt.getDate()+i);
               // dt= zeroDate;
               console.log("this.zeroDate" + JSON.stringify(dt));
                dt1.setDate( dt1.getDate()+i);
               // dt1 = zeroDate1;
               console.log("this.zeroDate" + JSON.stringify(dt1));
                var item ={
                    num:0,
                    dateKey:util.formatTime(dt,4)
                }
                var item1 ={
                    num:0,
                    dateKey:util.formatTime(dt1,4)
                }
                thisweek.push(item);
                lastweek.push(item1)
            }
            this.thisWeekList=thisweek;
            this.lastWeekList = lastweek;

        },
        changeDay(flag){
           // console.log("in changeDay")
            if(flag==1){
                 var a=  new Date();
                 if(a.getFullYear() == this.newDate.getFullYear() &&  this.newDate.getMonth()==a.getMonth() &&this.newDate.getDate()>=a.getDate()){
                    return;
                }
                this.newDate.setDate(this.newDate.getDate()+1);
                this.newDatestr = util.formatTime(this.newDate,4)

            }else{
                if( this.newDate.getFullYear()==2020 && this.newDate.getMonth()==0 &&this.newDate.getDate()==1){
                    return;
                }
                this.newDate.setDate(this.newDate.getDate()-1);
                this.newDatestr = util.formatTime(this.newDate,4)
            }
            this.getteamReportAction();

        },
        orgApiListAction(){
            let params = {
               // companyId:'2',
                companyId:this.common.userTenantInfo.companyId,
            }
            orgApiList(params).then(res => {
                if (res.res.code === 10000 && res.body) {
                    var list =[];
                    var aItem ={name:'全部部门',id:''};
                    list.push(aItem);
                    list= list.concat(res.body.list);
                    this.orgList =list;
                    console.log("this " +JSON.stringify(this.orgList) )
                    //this.orgNameList=[];
                    var nameList=[];
                    for(var i=0;i<this.orgList.length;i++){
                        nameList.push(this.orgList[i].name);
                    }
                    this.orgNameList[0].values=nameList;
                }
            })
        },

         select(pickType){
            this.pickType=pickType;
            this.popupVisible=true;
            this.pickList = this.orgNameList;

        },
        onValuesChange (picker, values) {
            if (values[0] > values[1]) {
                picker.setSlotValue(1, values[0]);
            }
        },

        handleConfirm(){
            this.popupVisible = false
            var valve =  this.$refs.picker.getValues()[0];
            this.orgname=valve
            var list =this.orgNameList[0].values;
            for(var i=0;i<list.length;i++){
                if(valve==list[i]){
                    this.orgId=this.orgList[i].id;
                }
            }
            this.getteamReportAction();
        },

        changeWeek(index){
            this.isThisWeek =index;
            this.reSetTableData();
        },
        tableSelect(index){
            this.tableSelectIndex =index;
        },
//         function isSameWeek(old,now){
// 2     var oneDayTime = 1000*60*60*24;
// 3     var old_count =parseInt(old.getTime()/oneDayTime);
// 4     var now_other =parseInt(now.getTime()/oneDayTime);
// 5     return parseInt((old_count+4)/7) == parseInt((now_other+4)/7);
// 6 }
        getWeek(dt){
            let curDate = new Date(dt);
            var a = curDate.getFullYear();
            var b = curDate.getMonth() + 1;
            var c = curDate.getDate();


            var date1 = new Date(a, parseInt(b) - 1, c)
            var date2 = new Date(a, 0, 1)
            var d = Math.round((date1.valueOf() - date2.valueOf()) / 86400000);
            if(curDate.getDay() ==0){
                return Math.ceil(
                    (d + (date2.getDay() + 1 - 1)) / 7
                 )+1;
            }
            return Math.ceil(
                (d + (date2.getDay() + 1 - 1)) / 7
            );


            // let d1 = new Date(dt);
            // let d2 = new Date(dt);
            // d2.setMonth(0);
            // d2.setDate(1);
            // let rq = d1-d2;
            // let days = Math.ceil(rq/(24*60*60*1000));
            // let num = Math.ceil(days/7);
            // let d1 = new Date(dt);
            // var oneDayTime = 1000*60*60*24;
            // var old_count =parseInt(d1.getTime()/oneDayTime);
            // return parseInt((old_count+3)/7);
        },
        //重置图表数据
        reSetTableData(){
            var weekList='';
            this.tableSelectIndex =-1;
            if(this.isThisWeek){
                weekList =this.thisWeekList;
            }else{
                weekList =this.lastWeekList;
            }
             var count =7;
             var self =this;
             if( weekList.length<7){
                    count = weekList.length;
             }
             var max=0;
             for (let i = 0; i < count; i++) {
                   if(weekList[i].num>max){
                        max = weekList[i].num;
                   }
             }
             if(max<5){  //最小可画图标
                 max =5;
             }
             self.maxValue =max;

             self.tableNumbels=[];
             self.maxTable =self.maxValue*1.2;
             for(var i=0;i<6;i++){
                 var num = parseInt(self.maxTable -i*self.maxTable/6)
                 self.tableNumbels.push(num);
             }

             self.tableList =[];
             for(var i=0;i<count;i++){
                 var maxh =240;
                 var h= weekList[i].num/this.maxTable*maxh
                // console.log('max  === ' +h)
                 var item ={
                        height:h,
                        value :weekList[i].num,
                        name :weekList[i].dateKey,
                  }
                  self.tableList.push(item)
             }


        },

        getteamReportAction(){
             let params = {
                // companyId:'2',
                companyId:this.common.userTenantInfo.companyId,
                orgId:this.orgId,
                queryDate:this.newDatestr,
            }
           // console.log('params == ' +JSON.stringify(params))
            teamReport(params).then(res => {
                if (res.res.code === 10000 && res.body) {
                   // {"res":{"code":10000,"msg":"返回成功","timestamp":1586744471714},
                   //"body":{"normal":0,"unNormal":0,"late":0,"signinList":[],"weekReport":[]}}
                   this.normal = res.body.normal;
                   this.unNormal = res.body.unNormal;
                   this.late = res.body.late;
                   var weekList = res.body.weekReport;
                //    this.thisWeekList =[];
                //    this.lastWeekList =[];
                   this.initWeekList();
                  // var nweek = this.getWeek(res.res.timestamp);
                   for(var i=0;i<weekList.length;i++){
                        var item = weekList[i];
                        for(var j=0;j<this.thisWeekList.length;j++){
                                var jitem = this.thisWeekList[j];
                                if(jitem.dateKey==item.dateKey){
                                    jitem.num =item.num;
                                }
                        }
                        for(var n=0;n<this.lastWeekList.length;n++){
                                var nitem = this.lastWeekList[n];
                                if(nitem.dateKey==item.dateKey){
                                    nitem.num =item.num;
                                }
                        }

                    //    var item = weekList[i];
                    //    var iweek = this.getWeek(item.dateKey);
                    //    console.log("nweek  === " +nweek +   "  &iweek === " +iweek)
                    //    if(nweek ==iweek){
                    //        this.thisWeekList.push(item);
                    //    }else{
                    //        this.lastWeekList.push(item);
                    //    }
                   }
                   this.reSetTableData();
                }
            });
        },
    }
}
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container{
    //height:100vh;
    background:#ffffff;
}
.topBar{
    width: 100%;
    height: 120px;
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.topBar_left{
     display: flex;
    margin-left: 28px;
    align-items: center;
    flex-direction: row;
}
.topBar_left_icon{
    width: 32px;
    height: 32px;
    //background-color: red;
}
.topBar_left_span{
    margin-top: 2px;
    height:48px;
    font-size:32px;
    margin-left: 12px;
    margin-right: 12px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:48px;
}
.topBar_right{
     display: flex;
     margin-right: 28px;
     align-items: center;
     flex-direction: row;
}
.topBar_right_span{
    margin-right: 20px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:40px;
}
.topBar_right_icon{
    width: 24px;
    height: 24px;
    // background-color: blue;
}
.topMian{
    margin-left: 28px;
    margin-top: 4px;
    width:694px;
    height:420px;
    background:rgba(255,255,255,1);
    box-shadow:0px 4px 16px 0px rgba(0,0,0,0.1);
    border-radius:16px;
    display: flex;
    flex-direction: column;
}
.topMian_span1{
     width:694px;
     text-align: center;
     height:40px;
     margin-top: 40px;
     font-size:28px;
     font-family:PingFangSC-Regular,PingFang SC;
     font-weight:400;
     color:rgba(153,153,153,1);
     line-height:40px;
}
.topMian_div1{
    margin-top: 16px;
    // width:638px ;
    margin-left: 28px;
    flex-direction: row;
    display: flex;
}
.topMian_span2{
    width: 294px;
    height:80px;
    font-size:80px;
    // display: flex;
    text-align: right;
    font-family:'DIN-Medium';
    color:rgba(51,51,51,1);
    line-height:80px;
}
.topMian_span3{
    margin-left: 14px;
    margin-top: 20px;
    margin-right: 14px;
    height:60px;
    font-size:44px;
    font-weight:500;
    color:rgba(153,153,153,1);
    line-height:60px;
}

.topMian_span4{
    width: 294px;
    height:80px;
    font-size:80px;
    // display: flex;
    // font-family:DIN-Medium,DIN;\
    font-family:'DIN-Medium';
    color:rgba(51,51,51,1);
    line-height:80px;
}
.topMian_span8{
    width:694px;
    text-align: center;
    margin-top: 20px;
    font-size:28px;
    font-weight:400;
    color:rgba(23,64,218,1);
    line-height:40px;
}
.topMian_div2{
    width:694px;
    margin-top: 32px;
    display: flex;
    flex-direction: row;
    position: relative;
}
.topMian_div3{
    width:232px;
    height:152px;
    flex-direction: column;
    display: flex;
}
.topMian_span5{
    width:232px;
    text-align: center;
    margin-top: 12px;
    height:40px;
    font-size:28px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:40px;
}
.topMian_span6{
    width:232px;
    margin-top: 4px;
    text-align: center;
    height:56px;
    font-size:40px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:56px;
}
.topMian_span7{
    width:232px;
    margin-top: 4px;
    text-align: center;
    height:56px;
    font-size:40px;
    font-weight:500;
    color:rgba(253,152,56,1);
    line-height:56px;
}

.tableTop{
    margin-top: 60px;
    flex-direction: row;
    margin-left: 28px;
    width: 694px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.tableTop_span1{
    height:44px;
    font-size:32px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:44px;
}
.tableTop_right{
    border-radius:8px;
    display: flex;
    border:2px solid rgba(234,234,234,1);
    flex-direction: row;
}
.tableTop_right_span{
    width:100px;
    height:44px;
    text-align: center;
    text-align: center;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:44px;
}
.tableTop_right_span_border1{
    border-radius:8px 0px 0px 8px;
    border:2px solid rgba(23,64,218,1);
    color:rgba(23,64,218,1);
}
.tableTop_right_span_border2{
    border-radius:0px 8px 8px 0px;
    border:2px solid rgba(23,64,218,1);
    color:rgba(23,64,218,1);
}
.tableViewDanwei{
    margin-top: 28px;
    margin-left: 28px;
    height:28px;
    font-size:20px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:28px;
}
//* 图标 */
    .tableViewBG{
        margin-top: 28px;
        width:750px;
        margin-bottom: 100px;
        // height:330px;
        display: flex;
        background-color:rgba(255,255,255,1);
        flex-direction: column;
    }
    .tabletop{
        width:750px;
        height: 260px;
        display: flex;
        flex-direction: row;
    }
    .tablenumber{
        width: 70px;
        // height: 240px;
        display: flex;
        flex-direction: column;
        /* justify-content: flex-end; */
        padding-top: 2px;
    }
    .tablenumber_text{
        width: 70px;

        text-align: right;
        margin-bottom: 14px;
        height:26px;
        font-size:18px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:26px;
    }
    .tableMian{
        margin-left: 10px;
        padding-top: 14px;
        display: flex;
        width: 642px;
        // height: 240px;
        // background-color: blue;
        flex-direction: column;
        position: relative;
    }
    .tableTR{
        width: 642px;
        height: 40px;
        background-color: rgba(250,250,250,1);
    }
     .tableTR1{
        width: 642px;
        height: 40px;
        background-color: rgba(255,255,255,1);
    }
    .tablebgLine{
        width: 642px;
        height: 2px;
        background-color:#98DCC5;
    }

    .tableBars{
        width: 642px;
        height: 254px;
        display: flex;
        // background-color: red;
        position:absolute;
        left: 0px;
        bottom: 6px;
        flex-direction: row;
        align-items: flex-end;
    }
    .tableBar{
        width:84px;
        display: flex;
        // margin-left: 24px;
        margin-right: 10px;
        align-items: flex-end;
        /* justify-content: center; */
        flex-direction: column;
    }
    .tableBar_text{
        width: 84px;
        height:26px;
        font-size:22px;
        text-align: center;
        font-weight:500;
        color:#16BC84;
        line-height:26px;
        margin-bottom: 4px;
    }

    .tableBar_bar{
        margin-right: 24px;
        width:36px;
        display: flex;
        /* height:98px; */
        background-color:#98DCC5;
    }
    .selecttableBar{
        background-color: #16BC84;
    }

    .tableFoot{
        width:750px;
        display: flex;
        height: 70px;
        flex-direction: row;
    }
    .tableFoots{
        margin-top: 10px;
        margin-left: 80px;
        width: 642px;
        height: 70px;
        display: flex;
        flex-direction: row;
    }
    .tableFootText{
        width: 84px;
        height:26px;
        line-height:26px;
        font-size:18px;
        color:#999999;
        line-height:26px;
        text-align: center;
        margin-right: 10px;
        overflow:hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .bottomView{
        width: 100px;
        display: flex;
    }


</style>